import { getUuid } from '@sibe/utilities/common';
import { HsGeometryType } from '../../graphic-engine-new/geometry/geometry-type.enum';
import { HsIndexedGeometry } from '../../graphic-engine-new/geometry/indexed-geometry.class';
import type { HsGraphicsBuffer } from '../../graphic-render-new/types/graphic-buffer.type';
import { HsBufferType } from '../../graphic-render-new/enums/buffer-type.enum';
import type { HsGraphics } from '../../graphic-render-new/graphics.class';
import { HsBox } from '../../math-new/shapes/box.class';
import { HsSphere } from '../../math-new/shapes/sphere.class';
import type { HsIndexedGeometryData } from './indexed-geometry-data.class';

/**
 * Handles s make indexed geometry.
 */
export function hsMakeIndexedGeometry(
  graphics: HsGraphics,
  mesh: HsIndexedGeometryData,
  prepareForBatching: boolean = false
): HsIndexedGeometry | null {
  const vertices: Float32Array =
    mesh.vertices instanceof Float32Array ? mesh.vertices : Float32Array.from(mesh.vertices);
  const normals: Float32Array = mesh.normals instanceof Float32Array ? mesh.normals : Float32Array.from(mesh.normals);
  const indices: Uint32Array = mesh.indices instanceof Uint32Array ? mesh.indices : Uint32Array.from(mesh.indices);
  const box: HsBox = HsBox.makeFromArray(vertices);
  const sphere: HsSphere = HsSphere.makeSphereFromBoundingBox(box.min, box.max);
  const bufferArray: Float32Array = new Float32Array(vertices.length + normals.length);
  bufferArray.set(vertices);
  bufferArray.set(normals, vertices.length);
  const buffer: HsGraphicsBuffer | null = graphics.createBuffer(bufferArray);
  const indexBuffer: HsGraphicsBuffer | null = graphics.createBuffer(indices, HsBufferType.elementBuffer);
  if (buffer === null) {
    return null;
  }
  if (indexBuffer === null) {
    return null;
  }
  const geometry: HsIndexedGeometry = new HsIndexedGeometry(
    getUuid(),
    HsGeometryType.Triangles,
    box,
    sphere,
    vertices.length,
    indices.length,
    buffer,
    indexBuffer
  );
  if (prepareForBatching && indices.length <= 3000 && normals.length === vertices.length) {
    geometry.batchingIndices = mesh.indices instanceof Uint32Array ? indices.slice() : indices;
  }
  return geometry;
}
